module.exports = __webpack_public_path__ + "img/caas3m-m@2.fe8d30d6.jpg";